import { render, staticRenderFns } from "./bulma_containerprops.vue?vue&type=template&id=29f2cdf8&scoped=true&lang=html"
import script from "./bulma_containerprops.vue?vue&type=script&lang=js"
export * from "./bulma_containerprops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f2cdf8",
  null
  
)

export default component.exports